import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import { ListarEmpreendimentosPesquisaController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { ExportExcelListarVistoriasController } from "../../../../Controllers/Vistorias/GestaoDeVistorias/GestaoDeVistoriasControllers";

import {
    IGestaoDeEntregaChavesRequest,
    IGestaoVistoriaResponse,
} from "../../../../Interfaces/Vistorias/VistoriaEntregaDeChaves/GestaoDeEntregaChaves";
import StorageManagerCapys from "../../../../Tools/Storage";

interface IGestaoDeEntregaChavesProps {
    handleSubmit: (filter: IGestaoDeEntregaChavesRequest) => void;
    defaultFilter?: IGestaoDeEntregaChavesRequest;
    storageManager: StorageManagerCapys<IGestaoVistoriaResponse>;
    setIdEmpreendimento: Dispatch<SetStateAction<number | string>>;
    idEmpreendimento: string | number;
}

export default function FiltroEntregaChaves(
    props: IGestaoDeEntregaChavesProps
) {
    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;
    const FormMethods = useForm();
    const { reset } = FormMethods;
    const limparFiltro = {
        ID_PRODUTO_PAI: [],
        ID_CASO: 0,
        DS_NOME: "",
        ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS: [],
        DT_INICIO: "",
        DT_FIM: "",
        PESQUISA: "",
        PAGINA: 1,
    };
    return (
        <>
            <StickyToolbar active={Boolean(filter)}>
                <FormProvider {...FormMethods}>
                    <UnForm handleSubmit={hadleFilterFormSubmit} usingContext>
                        <div className="col-12 mt-3">
                            <label>Data Inicio do Caso</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_INICIO"
                                defaultValue={filter?.DT_INICIO}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Final do Caso</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_FIM"
                                defaultValue={filter?.DT_FIM}
                            />
                        </div>

                        <div className="col-12 mt-3">
                            <label>Emprendimento</label>
                            <UnForm.SearchSelect
                                controller={(searchValue: string) =>
                                    ListarEmpreendimentosPesquisaController(
                                        searchValue ?? ""
                                    )
                                }
                                {...FormMethods}
                                name="ID_PRODUTO_PAI"
                                onChange={(e) => props.setIdEmpreendimento(e)}
                                getDS={(e) => e.DS_EMPREENDIMENTO}
                                getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                                mode="multiple"
                                buscarEmpreendimento={true}
                            />
                        </div>
                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        "FILTRO_GESTAO_VISTORIA"
                                    );
                                    reset(limparFiltro);
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </FormProvider>
            </StickyToolbar>
            <ExportExcel
                baixarExcelController={async () =>
                    ExportExcelListarVistoriasController(
                        { ...filter, ID_PRODUTO_PAI: props.idEmpreendimento } ??
                            {}
                    )
                }
                nomeArquivo={`RelatorioEntregaDeChaves`}
            />
        </>
    );
}
